import React, { useState } from "react";
import House from "../../Assets/images/houso.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AllApartClasses from "./AllApartClasses";
import PaymentMethod from "./PaymentMethod";
import SelectDuration from "./SelectDuration";

function InviteReceived({ rental }) {
  const data = rental?.rentals?.[0] || rental;
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const [paymentMethodOpen, setPaymentMethodOpen] = useState(false);
  const [durationModalOpen, setDurationModalOpen] = useState(false);
  const [selectedTenure, setSelectedTenure] = useState(1);

  const handleProceedToPayDirectly = () => {
    setDurationModalOpen(true);
  };

  return (
    <>
      <AllApartClasses
        open={open}
        handleClose={handleClose}
        isProceedToPay={true}
        apartmentId={data?.apartmentId || data?.id}
        data={data}
        parentData={data}
      />

      <SelectDuration
        open={durationModalOpen}
        handleClose={() => setDurationModalOpen(false)}
        handleBack={() => setDurationModalOpen(false)}
        handleContinue={(durationStr) => {
          const tenure = parseInt(durationStr?.split(" ")[0]) || 1;
          setSelectedTenure(tenure);
          setDurationModalOpen(false);
          setPaymentMethodOpen(true);
        }}
        data={data}
      />

      <PaymentMethod
        open={paymentMethodOpen}
        handleClose={() => setPaymentMethodOpen(false)}
        data={{ ...data, tenure: selectedTenure, rentedApartmentClassId: data?.apartmentId }}
      />

      <div className="bg-white border border-gray-100 mb-4 shadow-sm rounded-xl p-4">
        <div className="flex justify-between gap-4">
          {/* Left: Image */}
          <div className="w-[120px] md:w-[140px]">
            <img
              src={data?.apartmentImages?.[0]?.imageUrl || House}
              alt=""
              className="w-full object-cover rounded-lg"
            />
          </div>

          {/* Right: Content */}
          <div className="flex flex-col flex-1">
            <div className="flex justify-between items-start mb-1">
              <h3 className="text-[#1E222B] font-[600] text-[16px]">
                {data?.title || ""}
              </h3>
              <p className="text-[#00BC67] font-[600] rounded-md py-1 px-3 text-[12px] bg-[#E6F8F0]">
                Invite Received
              </p>
            </div>

            <p className="text-[#1E222B] font-bold text-[16px] mb-1">
              {`(Rooms: ${data?.bedrooms || 0})`}
            </p>

            <p className="text-[#1E222B] font-bold text-[13px] mb-4">
              Property ID: {data?.id || ""}
            </p>

            <div className="bg-[#F8FAFC] rounded-lg p-2 flex gap-2 items-start mt-auto">
              <InfoOutlinedIcon
                className="text-[#00BC67]"
                sx={{ fontSize: 18, marginTop: "2px" }}
              />
              <div className="gap-1">
                <p className="text-[#1E222B] text-[12px] font-bold">
                  Your invite has been accepted. You can now proceed.
                </p>
                <p className="text-[#00BC67] leading-[150%] text-[12px] font-semibold">
                  Please review the apartment class details before finalizing
                  your rental agreement
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-3 mt-4">
          <button
            onClick={handleOpen}
            className="flex-1 bg-[#E6F8F0] hover:bg-[#CCF2E1] transition-colors text-[#00BC67] font-[600] text-[14px] py-3 rounded-lg"
          >
            View Apartment
          </button>
          <button
            onClick={handleProceedToPayDirectly}
            className="flex-1 bg-[#00BC67] hover:bg-[#00a85a] transition-colors text-white font-[600] text-[14px] py-3 rounded-lg"
          >
            Proceed to pay
          </button>
        </div>
      </div>
    </>
  );
}

export default InviteReceived;
